import projectData from './projectData'

export const featuredProjectData: IFeaturedProject[] = projectData
export default featuredProjectData
